<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="conditions.orderId" placeholder="请输入订单号" clearable />
          </el-form-item>
          <el-form-item>
            <el-input v-model="conditions.phone" placeholder="请输入手机号" clearable />
          </el-form-item>
          <el-form-item>
            <el-select v-model="conditions.payState" placeholder="支付状态" clearable>
              <el-option label="已支付" value="PAID" />
              <el-option label="未支付" value="UNPAID" />
              <el-option label="已退款" value="REFUNDED" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryData">
              <i class="el-icon-search"></i> 查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>二维码收款记录</span>
      </div>
      <div class="">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="orderId" label="订单号" align="center" width="180" />
          <el-table-column prop="orderAmount" label="订单金额" align="center" />
          <el-table-column prop="ownerName" label="业主姓名" align="center" />
          <el-table-column prop="roomNum" label="房号" align="center" />
          <el-table-column prop="phone" label="手机号" align="center" />
          <el-table-column prop="giftIntegral" label="赠送积分" align="center" />
          <el-table-column label="支付状态" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.payState === 'PAID'" type="success">已支付</el-tag>
              <el-tag v-else-if="scope.row.payState === 'UNPAID'" type="warning">未支付</el-tag>
              <el-tag v-else-if="scope.row.payState === 'REFUNDED'" type="info">已退款</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="支付时间" align="center" />
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                :disabled="scope.row.payState !== 'PAID'"
                @click="_openRefundModal(scope.row)"
              >退款</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          :total="total" layout="total, prev, pager, next, jumper" style="margin-top: 20px;" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { listPayRecords, refundPayRecord } from '@/api/phone/shopQrCodeApi'

export default {
  name: 'ShopQrCodePayRecord',
  data() {
    return {
      conditions: {
        orderId: '',
        phone: '',
        payState: ''
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._queryData()
  },
  methods: {
    async _queryData() {
      try {
        const res = await listPayRecords({
          ...this.conditions,
          page: this.currentPage,
          row: this.pageSize,
          phoneLike: this.conditions.phone || ''
        })
        this.total = res.total
        this.list = res.data
      } catch (error) {
        console.error('查询失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._queryData()
    },
    _openRefundModal(row) {
      this.$confirm('确认对该笔收款发起退款？金额将原路退回', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await refundPayRecord({ recordId: row.recordId })
          if (res.code === 0) {
            this.$message.success('退款成功')
            this._queryData()
          }
        } catch (error) {
          console.error('退款失败:', error)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>
